import { Box, Button, Text, Typography } from "components/ui";
import { Formik } from "formik";
import React, { useState } from "react";
import { ActivityIndicator } from "react-native";
import { usePostGroupByIdCreategroupMutation } from "store/abcoApi";
import * as Yup from "yup";
import FormField from "./FormField";
import { router } from "expo-router";

interface GroupFormProps {
	parentId: number;
}

export default function GroupForm({ parentId }: GroupFormProps) {
	const [createGroup] = usePostGroupByIdCreategroupMutation();
	let [isSubmitting, setIsSubmitting] = useState(false);

	const validationSchema = Yup.object().shape({
		name: Yup.string().required("Group name is required").min(3, "Group name must be at least 3 characters"),
	});

	return (
		<Box>
			<Formik
				initialValues={{
					name: "",
				}}
				validationSchema={validationSchema}
				onSubmit={async (values, { resetForm }) => {
					setIsSubmitting(true);
					createGroup({ group: values, id: parentId }).then((res: any) => {
						setIsSubmitting(false);
						resetForm();
						return router.push({
							pathname: "admin/groups/[id]",
							params: { id: res.data },
						});
					});
				}}
			>
				{(formik) => (
					<Box gap={20}>
						<FormField label="Group Name" name="name" placeholder="Enter group name" formik={formik} />
						<Button width={120} variant="secondary" onPress={() => formik.handleSubmit()} disabled={formik.isSubmitting}>
							<Typography weight="bold">Save</Typography>
							{isSubmitting && <ActivityIndicator size="small" style={{ position: "absolute", right: 12 }} />}
						</Button>
					</Box>
				)}
			</Formik>
		</Box>
	);
}
